export const servicesContent = {
    es: {
        eyebrow: 'PRECIOS',
        title: 'Elige tu plan',
        planTitles: { basic: 'Plan Básico', premium: 'Plan Estándar', gold: 'Plan Premium' },
        badge: 'EL MÁS POPULAR',
        screensStandard: { basic: '1 dispositivo a la vez', premium: '1 dispositivo a la vez', gold: '2 dispositivos activos' },
        screensMulti: { basic: '2 dispositivos activos', premium: '3 dispositivos activos', gold: '4 dispositivos activos' },
        periodsStandard: { basic: '3 meses', premium: '12 meses', gold: '18 meses (6 gratis)' },
        periodsMulti: { basic: '15 meses (3 gratis)', premium: '15 meses (3 gratis)', gold: '15 meses (3 gratis)' },
        paymentOnce: 'Pago único',
        adultLine: 'Canales + películas para adultos (con contraseña) 🔞',
        beinStandard: 'beIN Sports, Canal+ y DAZN Sport, Rugby y Tenis',
        beinPremium: 'beIN Sports, Canal+ y DAZN Sport para Fútbol, Rugby y Tenis',
        features: [
            '+79.000 canales, +249.000 películas y series',
            'Todos los canales premium',
            'LaLiga + Champions League en FULL HD / 4K ⚽️',
            '__BEIN__',
            'Eurosport para La Vuelta, el Tour de Francia y Roland Garros',
            'DAZN, Amazon Prime, Netflix, Disney+, Movistar Plus+, Apple TV+',
            'Películas y series ilimitadas, SD / HD / FULL HD / 4K',
            'Servidores rápidos y estables, actualizados con regularidad',
            'Reproductor IBO Pro gratis incluido',
            'Atención al cliente 24/7 · Garantía de 15 días',
        ],
        orderButton: 'Pedir ahora',
        securePayment: 'Pago 100% seguro garantizado',
        whatsappOrderMessage: (title, price, period, screens) =>
            `Hola, quiero pedir el ${title} a ${price} (${period}, ${screens}). ¿Podéis ayudarme a finalizar mi pedido?`,
        supportTitle: '¿Necesitas más dispositivos o una duración distinta?',
        supportBody: 'Escríbenos y te preparamos un plan a medida, al momento.',
        supportCta: 'Hablar con soporte',
        lifetime: {
            badgeText: 'Oferta limitada',
            title: 'Plan de por vida',
            description: 'Un único pago, acceso permanente a tu suscripción premium: sin renovaciones ni sorpresas.',
            features: [
                { line1: 'Pago único', line2: '(sin suscripción)' },
                { line1: '2 pantallas simultáneas' },
                { line1: 'Acceso completo al', line2: 'plan Premium' },
                { line1: 'Garantía de devolución', line2: 'de 30 días' },
            ],
            priceNote: 'pago único',
            ctaLabel: 'Pedir',
            securityLabel: 'Pago 100% seguro',
            whatsappMessage: 'Hola, quiero pedir el Plan de por vida a 159,00 € (pago único). ¿Podéis ayudarme a finalizar mi pedido?',
        },
    },
};
